import { Breadcrumb } from 'antd';
import { ArrowLeftSolid, ChevronRightSolid } from '../../utils/icons';
import { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb';

const DLSBreadcrumb = ({ goBack, items }: { goBack: () => void; items: BreadcrumbItemType[] }) => {
  return (
    <div className="flex items-center">
      <div className="mr-[12px] flex cursor-pointer" onClick={goBack}>
        <ArrowLeftSolid />
      </div>
      <Breadcrumb items={items} separator={<ChevronRightSolid />} />
    </div>
  );
};

export default DLSBreadcrumb;
